import { useNavigate } from 'react-router-dom';
import OrganizationsPage from '../../OrganizationsPage';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function OrganizationsContainer() {
  const navigate = useNavigate();
  const { currentUser } = useLegacyAppSession();

  return (
    <OrganizationsPage
      isSuperUser={currentUser?.isSuperUser}
      currentUser={currentUser}
      onAdd={() => navigate('/organizations/new')}
      onEdit={(organization) => navigate(`/organizations/${organization.id}/edit`, {
        state: { organization },
      })}
    />
  );
}
